document.addEventListener('DOMContentLoaded', () => {
  const details = document.getElementById('Details-menu-drawer-container');
  if (!details) return;

  let scrollY = 0;

  function lock() {
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlock() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  const sync = () => details.open ? lock() : unlock();

  sync();
  details.addEventListener('toggle', sync);
});
